import { Edit, ShowButton, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";

const EditHospitality = () => {
  return (
    <Edit
      title="Редактиране на болница"
      mutationMode="pessimistic"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canPreviewHospitalities}>
              <ShowButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditHospitality;
